import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Añade `.dibujado` a cada `[data-dibuja]` cuando entra en pantalla, una sola vez:
 * los planos y las curvas de nivel se trazan al hacer scroll (ver index.css).
 * Se re-ejecuta al cambiar de ruta porque las páginas comparten componentes.
 */
export function useDibujaAlVer() {
  const { pathname } = useLocation();
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('[data-dibuja]:not(.dibujado)'));
    if (!els.length) return undefined;
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('dibujado'));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entradas) =>
        entradas.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('dibujado');
          io.unobserve(e.target);
        }),
      { threshold: 0.2 },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [pathname]);
}
